import { jsx as m } from "react/jsx-runtime";
import { useRef as p, useState as b, useEffect as E } from "react";
import { useDesignContext as d } from "../../../../../../providers/use-design-provider.mjs";
import { twMerge as v } from "tailwind-merge";
const C = ({ goToSlide: n, index: c, slidesCount: a }) => {
  const e = p(null), [l, s] = b(!1), { isDefaultSioColor: o } = d();
  let r = "";
  return l ? r = o ? "!bg-brand-primary" : "!bg-THEME-primary" : r = o ? "bg-THEME-tertiary" : "bg-THEME-secondary", E(() => {
    if (!e.current) return;
    const t = e.current.parentElement;
    if (!t) return;
    t.style.width = `${100 / a}%`, s(t.classList.contains("slick-active"));
    const i = new MutationObserver((u) => {
      u.forEach((f) => {
        f.attributeName === "class" && s(t.classList.contains("slick-active"));
      });
    });
    return i.observe(t, { attributes: !0 }), () => i.disconnect();
  }, []), /* @__PURE__ */ m(
    "div",
    {
      onClick: () => n(c),
      className: v("flex h-[4px] cursor-pointer rounded-[30px]", r),
      ref: e
    }
  );
};
export {
  C as default
};
